const translations = {
  "en": {
    "Biggest holding": "Biggest holding",
    "Bonds & cash": "Bonds & cash",
    "International": "International",
    "Other US": "Other US"
  },
  "zh-tw": {
    "Biggest holding": "最大持倉",
    "Bonds & cash": "債券與現金",
    "International": "國際",
    "Other US": "其他美國"
  }
};

export default translations;
